module.exports = __webpack_public_path__ + "img/the-netherlands-pneumonia-female.8f787b34.png";